import axios from 'axios';

axios.defaults.baseURL = 'https://api.lodge.devfik.com/api/v1';
